import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    toolbarContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    cardContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 240
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    historyFilterContainer: {
        alignSelf: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    rejectionReasonContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardDetailsContainer: {
        flexDirection: "column"
    },
    listContainer: {
        flexDirection: "column"
    },
    toolbarActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    historyStatusContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardCompanyContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardInfoContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        alignItems: "center"
    },
    searchInputContainer: {
        maxWidth: 360,
        flex: 1
    },
    userNameText: {
        fontWeight: "600"
    },
    userAvatar: {
        height: 44,
        width: 44
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
